<template>
<v-dialog v-model="dialog" scrollable max-width="980px" transition="dialog-transition" :fullscreen="$vuetify.breakpoint.smAndDown" persistent @keydown.esc="emitExit()">
    <v-card flat class="pa-3 hotel-modal" id="billing-hotel" height="100%">
        <v-card-title primary-title>
            <div class="pl-2">
                Date de facturare
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="6" class="py-0">
                    <div>
                        <div class="important">{{ $t('hotel.billing.profile') }}:
                            <span class="font-weight-bold my-1">{{ billing.name }}</span>
                        </div>
                        <div class="regular ml-3">{{ billing.fiscal_code }}</div>
                        <div class="regular ml-3">{{ billing.registry_number }}</div>
                        <div class="regular ml-3">
                            <span v-if="billing.address.street">, {{ billing.address.street }}</span>
                            <span v-if="billing.address.number">, {{ billing.address.number }}</span>
                            <span v-if="billing.address.building">, {{ billing.address.building }}</span>
                        </div>
                        <div class="regular ml-3">
                            {{ billing.address.city }}
                            <span v-if="billing.address.postal_code">, {{ billing.address.postal_code }}</span>
                        </div>
                        <div class="regular font-weight-medium ml-2 mt-2">
                            {{ $t('hotel.billing.bank') }}:
                        </div>
                        <div class="regular ml-3" v-for="(bank,index) in billing.banks" :key="index">
                            <div class>{{ bank.name }}</div>
                            <div class>{{ bank.account }} {{ bank.currency }}</div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="emitExit()">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_save" @click="save()">Save</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import logger from '../../../../logger.js';

export default {
    props: {
        dialog: Boolean,
        item: Object,
    },
    name: `item-hotel`,
    data() {
        return {
            org_id: null,
            loading_save: false,
            billing: {
                name: null,
                type: null,
                fiscal_code: null,
                registry_number: null,
                banks: [{
                    name: null,
                    account: null,
                    currency: null,
                }],
                contact: {
                    name: null,
                    email: null,
                    phone: null,
                    position: null,
                },
                address: {
                    country: null,
                    state: null,
                    city: null,
                    street: null,
                    number: null,
                    building: null,
                    postal_code: null,
                }
            },
        };
    },

    watch: {
        item: {
            handler() {
                this.getBillingDetail(this.item.org_id);
            }
        },
    },

    created() {
        this.getBillingDetail(this.item.org_id);
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getBillingDetail(value) {

            if(!value) {
                return
            }
            // construct params object
            let params = {
                params: {
                    owner_ids: [value]
                }
            };
            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/billings";

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.data[0]) {
                        this.billing = response.data.data[0];
                    }
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {});
        },
        save() {

        },
        emitExit() {
            this.$emit('exit')
        }
    },

};
</script>
